<template>
  <div class="connected-clients module">
    <div class="header medium">Connected clients</div>

    <div class="clients">
      <div class="client small" v-for="client in clients" :key="client.id">
        <div class="client-name">{{ client.name }}</div>
        <div v-if="client.duplicate" class="client-id">
          {{ client.id.slice(0,4) }}
        </div>
        <div class="client-time">{{ formatTime(client.connected) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../EventBus.js';
const dayjs = require('dayjs');

export default {
  data () {
    return {
      clients: []
    };
  },
  methods: {
    formatTime (str) {
      const now = dayjs();
      const d = dayjs(str);
      if (now.isSame(d, 'day')) {
        return 'today at ' + d.format('h:mm:ssa');
      }
      else {
        return d.format('MMM D, h:mm:ssa');
      }
    },
    fetchLatest () {
      const xreq = new XMLHttpRequest();
      xreq.responseType = 'json';
      xreq.open('GET', '/api/v1/clients');

      xreq.onerror = () => {
        EventBus.$emit('log', {
          level: 'e',
          message: 'error while fetching /api/v1/clients'
        });
      };

      xreq.onload = () => {
        if (xreq.status !== 200) {
          EventBus.$emit('log', {
            level: 'e',
            message: 'non-200 status while fetching /api/v1/clients'
          });
          return;
        }

        this.clients = xreq.response;
      };

      xreq.setRequestHeader('X-Key', this.$store.state.key);
      xreq.send();
    }
  },
  watch: {
    clients () {
      const counts = {};
      // loop through, and if duplicates found, tag to show client key
      this.clients.forEach((cl) => {
        if (!counts[cl.name]) counts[cl.name] = 1;
        else counts[cl.name]++;
      });

      this.clients.forEach(cl => {
        cl.duplicate = counts[cl.name] > 1;
      });
    }
  },
  created () {
    EventBus.$on('log', (msg) => {
      // listen for messages about joins/leaves, and refetch
      if (msg.channel === 'connectivity') {
        this.fetchLatest();
      }
    });

    setTimeout(() => {
      this.fetchLatest();
    }, 2500);
  }
};
</script>

<style lang="scss" scoped>
  .clients {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .client {
    width: 33%;
    line-height: 1.5em;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    margin-top: 30px;
  }

  .client:nth-child(1), .client:nth-child(2), .client:nth-child(3) {
    margin-top: 0;
  }

  .client-id {
    color: #bbb;
    font-size: 0.75rem;
    font-family: 'Roboto Mono', monospace;
    padding-left: 10px;
  }

  .client-time {
    color: gray;
    flex-basis: 100%;
  }
</style>
